// extracted by mini-css-extract-plugin
module.exports = {"pointer":"filters_pointer__20Tbb","filterContainer":"filters_filterContainer__IYoIr","filterLabel":"filters_filterLabel__rlT3O","filterIcon":"filters_filterIcon__3BLcy"};